<template>
  <div v-if="isPermission">
    <select-shop :loadingButton="loadingButton" v-on:getData="getProductPackage"></select-shop>
    <div v-if="isOrderBuffetEnabled">
      <CCard>
        <CCardBody>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4>{{$t('packageProductManagement') }}</h4>
            <div>
              <CButton
                color="danger" v-if="isDeleteData"
                :disabled="selectedForDelete.length === 0 || bulkDeleting"  
                @click="bulkDeleteModal = true"
                class="mr-2"
              >
                <i class="fi fi-rr-trash mr-1"></i> {{$t('deletePagekage')}} ({{ selectedForDelete.length }})
              </CButton>
              <router-link v-if="isEditData" to="/product/package/add" class="btn btn-primary"><i class="fi fi-rr-plus"
                  style="margin-right: 8px;"></i> {{$t('addPackage')}}</router-link>
            </div>
          </div>
          <div style="overflow-y: auto; white-space:nowrap;">
            <DataTable :fields="fields" :items="items" responsive>
              <template #head(selected)>
                <div class="text-left mt-1 ml-2" style="width: 70px;">
                    <div class="custom-checkbox-wrapper">
                    <input
                        type="checkbox"
                        id="selectAll"
                        :checked="areAllSelected"
                        @change="toggleSelectAll"
                        class="custom-checkbox-input"
                    />
                    <label for="selectAll" class="ml-2 mb-0">{{$t('all')}}</label>
                    </div>
                </div>
            </template>
              <template #selected="{ item }" >
                <td class="text-left pl-3" style="width: 70px;">
                  <input type="checkbox" v-model="selectedForDelete" :value="item" />
                </td>
              </template>
              <template #remoteImagePath="{ item }">
                <td class="text-left" style="width: 60px;">
                  <div v-if="item.remoteImagePath" style="width: 50px; aspect-ratio: 4 / 3;">
                    <img
                      :src="item.remoteImagePath" @error="noImgUrl"
                      alt="package"
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;"
                    />
                  </div>
                  <div
                    v-else
                    class="image-placeholder"
                    :style="{ 'aspect-ratio': '4 / 3', backgroundColor: generateColor(item.indexColor), 'border-radius': '3px' }"
                    style="width: 50px;"
                  >
                  </div>
                </td>
              </template>

              <template #products="{ item }">
                <td class="text-center text-dark">
                  {{ item.ProductSKUPackage?.length || 0 }}
                </td>
              </template>
              <template #description="{ item }">
                <td class="text-dark text-left" style="width: 300px; padding: 4px;">
                  <div
                    style="
                      overflow: auto;  
                      max-height: 3.6em;       /* ประมาณ 3 บรรทัด */
                      overflow: auto;     
                      font-size: 0.9em;        /* ขนาดเล็กลง */
                      line-height: 1.2em;
                      white-space: pre-line;   /* รองรับ \n */
                    "
                  >
                    <span v-if="item.description && item.description.trim() !== ''">{{ item.description }}</span>
                    <span v-else class="text-muted"></span>
                  </div>
                </td>
              </template>
              <template #category="{ item }">
    
                <td class="text-center text-dark">
                  {{ Array.from( new Set( item.ProductSKUPackage?.map(p => p.productSKU.category?.objectId || 'ไม่ระบุหมวด'))).length}}
                </td>
              </template>
              <template #updated_at="{ item }">
                <td class="text-dark">
                  {{ formatDate(item.updated_at) }}
                </td>
              </template>
              <template #actions="{ item, index }">
                <td class="text-center text-dark">
                  <CRow>
                    <CCol col="6">
                      <router-link style="text-decoration:none;" :to="{
                        name: 'EditProductPackage',
                        params: { objectId: item.objectId },
                        query: queryparams,
                      }">
                        <img src="/img/file-edit.png" style="width: 14px; height: 14px; cursor: pointer;" />
                      </router-link>
                    </CCol>
                    <CCol col="6">
                      <img src="/img/trash.png" style="width: 14px; height: 14px; cursor: pointer; " v-if="isDeleteData"
                        @click="confirmdelete(item)">
                    </CCol>
                  </CRow>
                </td>
              </template>
            </DataTable>
          </div>
          <pagination :meta_data="meta_data" @getData="getProductPackage"></pagination>
        </CCardBody>
      </CCard>
      <CModal
        :show.sync="deleteModal"
        color="danger"
        :title="$t('confirmDeletePackage')"
      >
        <div class="text-center mt-2">
          <p class="mb-0">
            {{ $t('confirmDeletePackageQuestion', { name: itemDelete ? (itemDelete.name || '...') : '' }) }}
          </p>
        </div>
        <template #footer-wrapper>
          <CRow class="m-2">
            <CCol col="6">
              <CButton color="secondary" block @click="deleteModal = false">
                {{$t('cancel')}}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton color="danger" block @click="deleteConfirmed" :disabled="deleting">
                {{ deleting ? $t('deleting') : $t('confirmDeletePackage') }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
      <!-- Confirm modal สำหรับการลบหลายรายการ -->
      <CModal
        :show.sync="bulkDeleteModal" :title="$t('confirmDeletePackageMuliti')"
        @close="bulkDeleteModal = false" color="danger"
        centered
      >
        <div class="text-center">
          <p class="mb-0">
            {{ $t('confirmDeletePackagesQuestion', { count: selectedForDelete.length }) }}
          </p>
          <div style="max-height: 300px; overflow-y: auto;">
            <CListGroup class="text-left" >
              <CListGroupItem v-for="(pkg, index) in selectedForDelete" :key="pkg.objectId" class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <!-- รูปภาพแพ็กเกจ -->
                  <img
                    v-if="pkg.remoteImagePath"
                    :src="pkg.remoteImagePath"
                    alt="package"
                    style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 8px;"
                  />
                  <div
                    v-else
                    :style="{ backgroundColor: generateColor(pkg.indexColor) }"
                    style="width: 40px; height: 40px; border-radius: 4px; margin-right: 8px;"
                  ></div>

                  <!-- ชื่อแพ็กเกจ -->
                  <span>{{ pkg.name || '...' }}</span>
                </div>
                <!-- ปุ่มลบออกจากรายการยืนยัน -->
                <i
                  class="fi fi-rr-trash text-danger"
                  style="cursor: pointer;"
                  @click="removeFromBulkList(index)"
                ></i>
              </CListGroupItem>
            </CListGroup>
          </div>
        </div>
        <template #footer-wrapper>
          <CRow class="m-2">
            <CCol col="6">
              <CButton color="secondary" block @click="bulkDeleteModal = false">
                {{$t('cancel')}}
              </CButton>
            </CCol>
            <CCol col="6">
              <CButton color="danger" block  @click="confirmBulkDelete">
                {{$t('confirmDeletePackage')}}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
    </div>
    <div v-else class="text-center">
      <CCard>
        <CCardBody>
          <img src="/img/BF-banner.jpg" alt="Feature Not Available" style="    width: -webkit-fill-available; " />
        </CCardBody>
      </CCard>
    </div>
  </div>
  <div v-else>
      <access-data></access-data>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Pagination from "@/containers/Pagination";
import util from "@/util/util";
import pos from "@/services/local";
import DataTable from '@/containers/DataTable'
import permis from '@/util/permission'
import moment from 'moment'

export default {
  name: 'PackageIndex',
  components: {
    Pagination,
    DataTable
  },
  data() {
    return {
      loadingButton: true,
      keyword: this.$route.query.keyword || "",
      searchBy: this.$route.query.searchBy || "",
      sort_value: {
        name: "SKUName",
        updated_at: "updated_at",
        category: "category.name",
        sortByNumMin: "sortByNumMin",
        sortByNumMax: "sortByNumMax",
      },
      sortdata: this.$route.query.sort || "SKUName",

      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: 50,
        itemCount: 0,
      },
      deleteModal: false,
      itemDelete: null,
      selectedForDelete: [],
      packageList: [],
      bulkDeleteModal: false,
      deleting: false, 
      bulkDeleting: false, 
      orderShopSetting: {},
      isOrderBuffetEnabled : false,
    };
  },
  watch: {
    shopObjectId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getOrderShopSetting()
        this.getProductPackage()

      }
    }
  },
  created() {
    this.getOrderShopSetting()
    this.getProductPackage();
  },  
  computed: {
    ...mapGetters(["shops", "users", "date", "shopsetting"]),
    // isPermission() {
    //   return permis.findPermissionRead('inventory', this.$route.path)
    // },
    // isEditData() {
    //   return permis.findPermissionEdit('inventory', this.$route.path)
    // },
    isPermission() {
      return permis.findPermissionRead('product', this.$route.path)
      // return true; // For testing purposes, always allow read
    },
    isEditData() {
      return permis.findPermissionEdit('product', this.$route.path)
      // return true; // For testing purposes, always allow edit
    },
    isDeleteData() {
      return permis.findPermissionRemove('product', this.$route.path)
      // return true; // For testing purposes, always allow delete
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },

    queryparams() {
      return {
        sort: this.sortdata,
        page: this.meta_data?.current_page || 1,
        searchBy: this.searchBy,
        keyword: this.keyword,
      };
    },
    queryURL() {
      return (
        "?sort=" +
        this.sortdata +
        "&page=" +
        this.page +
        "&searchBy=" +
        this.searchBy +
        "&keyword=" +
        this.keyword
      );
    },
    items() {
      return this.packageList;
    },
    fields() {
      return [
        { key: 'selected', label: '', _classes: 'text-center' , _style: 'width: 50px;'},
        { key: 'remoteImagePath', label:  this.$t("packageName"), _classes: "text-center",_style: 'width: 50px;' },
        { key: 'name', label: '', sortable: true, _classes: "text-dark text-left" },
        { key: 'description', label: this.$t("packageDes"), sortable: true, _classes: "text-dark text-left" , _style: 'width: 250px;'},
        { key: 'products', label: this.$t('productInPackage'), _classes: "text-dark text-center" },
        // { key: 'category', label: this.$t("category"), _classes: "text-dark text-center" },
        { key: 'updated_at', label: this.$t("date"), sortable: true, _classes: "text-dark text-left" },
        { key: 'actions', label: '', _classes: "text-dark text-right" }
      ];
    },
    areAllSelected() {
      return this.selectedForDelete.length === this.items.length && this.items.length > 0;
    },
    uid() {
        return `${localStorage.getItem('shopsUid')}`
    },
  },
  methods: {
    ...util,
    getOrderShopSetting(){
      const shopObjectId = `${localStorage.getItem('shopObjectId')}`
      let params = {
          shopObjectId: shopObjectId,
      }
      const headers = {
          shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      }
      pos({
          url: "/api/v3.0/shop/ordershopsetting",
          params: params,
          headers: headers,
          method: "get",
      }).then((res) => {
          if(res.status ==200){
              let isOrderBuffetEnabled  = res.data.data.isOrderBuffetEnabled
              if(isOrderBuffetEnabled!== undefined && isOrderBuffetEnabled !== null && isOrderBuffetEnabled!==''){
                  this.isOrderBuffetEnabled = isOrderBuffetEnabled
              }else{
                  this.isOrderBuffetEnabled = false
              }
          }else{
              this.isOrderBuffetEnabled = false
          }
          
      }).catch((error) => {
              console.log(error);
      });
    },
    toggleSelectAll() {
      if (this.areAllSelected) {
        this.selectedForDelete = [];
      } else {
        this.selectedForDelete = [...this.items];
      }
    },
    noImgUrl(event) {
        event.target.src = process.env.VUE_APP_NOIMAGE
    },
    removeFromBulkList(index) {
      this.selectedForDelete.splice(index, 1)
    },
    deleteProductPackage(index, pkg) {
      this.selectedForDelete.splice(index, 1);
      const shopObjectId = this.shopObjectId
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)}
      let data = {
        shopObjectId: shopObjectId,
        objectId: pkg.objectId,
      }
      pos({
        method: 'POST',
        url: '/api/v3.0/'+ this.uid +'/productpackage/softdelete/many',
        data: data,
        headers: headers,
      })
        .then(
          setTimeout(() => {
            this.isDeleteSuccess = true
            this.deleteModal = false
            this.addUnitModal = false
            this.loadingSaveButton = false
            this.getUnit()
          }, 1000)
        )
        .catch((error) => {
          console.log(error)
        })
    },
    formatDate(date) {
      if (date) {
        return moment(String(date)).format('DD/MM/YYYY HH:mm');
      }
      return '';
    },
    getProductPackage(page = this.$route.query.page || 1) {

      const shopObjectId = this.shopObjectId
      const headers = { shopObjectId : util.sanitizeShopObjectId(shopObjectId)}
      let params = {
        page: page,
        limit: this.meta_data.limit,
      }

      pos({
        url : '/api/v3.0/' + this.uid +'/productpackage/all',
        params: params,
        headers: headers,
        method: 'GET',
      }).then((res) => {
        if (res.data.error.code == 0) {
            this.packageList = res.data.data

            if (res.data?.paginate) {
              this.meta_data.current_page = res.data.paginate.currentPage || 1
              this.meta_data.itemCount    = res.data.paginate.itemCount || 0
              this.meta_data.items        = res.data.paginate.items || 0
              this.meta_data.last_page    = res.data.paginate.pageCount || 1
            }
        }else{
          this.packageList = []
        }

      })
    },
    confirmdelete(item) {
      this.deleteModal = true
      this.itemDelete = item
    },
    async deleteConfirmed() {
      if (!this.itemDelete?.objectId) return
      const objectId    = this.itemDelete.objectId
      const shopObjectId = this.shopObjectId
      const headers     = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) }

      try {
        this.deleting = true
        const res = await pos({
          method: 'POST',
          url: `/api/v3.0/${this.uid}/productpackage/softdelete`,
          data: { shopObjectId, objectId },
          headers,
        })

        // success format แบบ softDelete เดิม: error.code === 0 แปลว่าสำเร็จ
        if (res.data?.error?.code === 0) {
          // เอา item ออกจาก list
          this.packageList = this.packageList.filter(pkg => pkg.objectId !== objectId)
          this.$toast.success('ลบแพ็กเกจเรียบร้อยแล้ว')
        } else {
          const msg = res.data?.error?.message || 'ลบไม่สำเร็จ'
          this.$toast.error(msg)
        }
      } catch (e) {
        console.error(e)
        this.$toast.error('ลบแพ็กเกจไม่สำเร็จ')
      } finally {
        this.deleting = false
        this.itemDelete = null
        this.deleteModal = false
      }
    },
    confirmBulkDelete() {
      this.bulkDelete();
      this.bulkDeleteModal = false;
    },
    async bulkDelete() {
      if (!this.selectedForDelete.length) return
      const shopObjectId = this.shopObjectId
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) }
      const itemsPayload = this.selectedForDelete.map(p => ({ objectId: p.objectId }))

      try {
        this.bulkDeleting = true
        const res = await pos({
          method: 'POST',
          url: `/api/v3.0/${this.uid}/productpackage/softdelete/many`,
          data: { shopObjectId, items: itemsPayload },
          headers,
        })

        if (res.data?.error?.code === 0) {
          const details = res.data?.data?.details || []
          const okIds = details
            .filter(d => d.status === 'ok')
            .map(d => d.objectId)

          // ตัดรายการที่ลบสำเร็จออกจาก list
          this.packageList = this.packageList.filter(pkg => !okIds.includes(pkg.objectId))

          const failed = details.filter(d => d.status === 'error').length
          const skipped = details.filter(d => d.status === 'skip').length

          if (failed === 0) {
            this.$toast.success(this.$t('bulkDeleteSuccess', { count: okIds.length }))
          } else {
            this.$toast.warning(this.$t('bulkDeletePartial', { ok: okIds.length, failed, skipped }))
          }
        } else {
          const msg = res.data?.error?.message || this.$t('bulkDeleteFailed')
          this.$toast.error(msg)
        }
      } catch (e) {
        console.error(e)
        this.$toast.error(this.$t('bulkDeleteFailed'))
      } finally {
        this.bulkDeleting = false
        this.selectedForDelete = []
        // ถ้าต้องการ reload จากเซิร์ฟเวอร์อีกรอบ:
        // await this.getProductPackage(this.meta_data.current_page)
      }
    },
  },
  mounted() {
    // Code to run when the component is mounted
  }
};
</script>